import { tokenizeQuery, renderToHTML } from '@cade/syntax-highlight';
import type { QueryLanguage } from '@cade/syntax-highlight';

export type { QueryLanguage } from '@cade/syntax-highlight';

export function highlightQuery(code: string, lang: QueryLanguage): string {
  return renderToHTML(tokenizeQuery(code, lang));
}
